import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const parcelLocaleModule: LocaleModule = {
  name: "parcel",
  messages: { en: en, it: it },
};
